import _Toast from "@kibt/meta-ui/es/toast";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import MyBox from '../sub-components/box.vue';
import { isInApp, useBridge } from '@/utils/yoda';
import { toProfile } from '@/utils/ikwai';
import MyButton from '../sub-components/my-button.vue';
export default defineComponent({
  components: {
    MyBox: MyBox,
    MyButton: MyButton
  },
  props: {
    winners: {
      type: Array,
      required: true
    }
  },
  emits: ['change-video'],
  setup: function setup(props, ctx) {
    // 这里保存，而不是修改原始的displayedUsers.following,因为传到上面太多层级了
    var followUserMap = ref({});

    var changeUserFollow = function changeUserFollow(userId, following) {
      ctx.root.$set(followUserMap.value, userId, following);
    }; // 获取真正的用户关注情况


    var getUserFollowing = function getUserFollowing(user) {
      if (followUserMap.value[user.userId] === true || followUserMap.value[user.userId] === false) {
        return followUserMap.value[user.userId];
      }

      return user.following;
    };

    var hasFollowedCount = computed(function () {
      return props.winners.filter(function (item) {
        return getUserFollowing(item);
      }).length;
    });
    var currentUser = ref(null);

    var handleProfileClick = function handleProfileClick(user) {
      currentUser.value = user;
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var namespace, canuseRes;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (isInApp) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              namespace = 'business'; // 老版本兼容

              _context2.next = 5;
              return yoda.tool.canIUse({
                namespace: namespace,
                name: 'reqeustFollowStatus'
              });

            case 5:
              canuseRes = _context2.sent;

              if (!canuseRes.canUse) {
                namespace = 'bussiness';
              }

              yoda.event.addEventListener('resume', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var res;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!currentUser.value) {
                          _context.next = 5;
                          break;
                        }

                        _context.next = 3;
                        return useBridge(namespace, 'reqeustFollowStatus', {
                          userIdToQuery: currentUser.value.userId
                        });

                      case 3:
                        res = _context.sent;

                        if (res.result === 1) {
                          changeUserFollow(currentUser.value.userId, res.followStatus === 1);
                        }

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))); // 关注或取消关注

    var changeFollow = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(user) {
        var userFollowing, currentUserId, namespace, canuseRes, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userFollowing = getUserFollowing(user);
                currentUserId = user.userId;
                _context3.next = 4;
                return yoda.ready();

              case 4:
                namespace = 'business'; // 老版本兼容

                _context3.next = 7;
                return yoda.tool.canIUse({
                  namespace: namespace,
                  name: 'changeFollowStatus'
                });

              case 7:
                canuseRes = _context3.sent;

                if (!canuseRes.canUse) {
                  namespace = 'bussiness';
                }

                _context3.next = 11;
                return useBridge(namespace, 'changeFollowStatus', {
                  toFollow: !userFollowing,
                  toUid: currentUserId.toString()
                });

              case 11:
                res = _context3.sent;

                if (res.result === 1) {
                  _Toast.show({
                    text: userFollowing ? 'Deixou de seguir' // 已取消关注
                    : 'Sucesso'
                  }); // ctx.emit('change-follow-user', currentUserId, !props.following);


                  changeUserFollow(currentUserId, !userFollowing);
                } else {
                  _Toast.show({
                    // 这里为true，说明用户已关注，想取消但失败了
                    text: 'Ocorreu um erro, tenta de novo'
                  });
                }

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function changeFollow(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    var showMore = ref(false);

    var handleShowMore = function handleShowMore() {
      showMore.value = !showMore.value;
    };

    var computedWinners = computed(function () {
      if (showMore.value) {
        return props.winners;
      }

      return props.winners.slice(0, 40);
    });
    return {
      getUserFollowing: getUserFollowing,
      changeFollow: changeFollow,
      toProfile: toProfile,
      handleProfileClick: handleProfileClick,
      handleShowMore: handleShowMore,
      computedWinners: computedWinners,
      showMore: showMore,
      hasFollowedCount: hasFollowedCount
    };
  }
});